export default __webpack_public_path__ + "static/media/mint_box.7115e038.png";